import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <section className="relative h-screen w-full overflow-hidden bg-matte" data-id="element-51">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full" data-id="element-52">
        <motion.img initial={{
        scale: 1.05,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=1920&q=80" alt="Primer plano de un perro con luz natural" className="w-full h-full object-cover object-center" data-id="element-53" />
        {/* Gradient Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-matte/90 via-matte/40 to-transparent" data-id="element-54" />
      </div>

      {/* Content */}
      <div className="relative h-full w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-32" data-id="element-55">
        <div className="max-w-3xl" data-id="element-56">
          <motion.h1 initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-5xl md:text-7xl lg:text-8xl text-cream mb-6 leading-[1.1] text-balance" data-id="element-57">
            Expertos en quienes ellos confían
          </motion.h1>

          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-lg md:text-xl text-cream/90 font-light mb-10 max-w-xl text-balance" data-id="element-58">
            Medicina veterinaria avanzada con el corazón puesto en su bienestar.
          </motion.p>

          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-59">
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-block bg-olive hover:bg-olive-light text-cream px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-300" data-id="element-60">
              Reservar turno por WhatsApp
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}